export default __webpack_public_path__ + "static/media/play.8f490be0.svg";